/**
 * Handler per la propagazione delle impostazioni delle DataTable
 * Compatibile con Vue.js - non utilizza tag <script> nei template
 */
export default class PropagationHandler {
    
    constructor() {
        this.init();
    }
    
    init() {
        // Controlla se c'è una sessione che richiede il popup di propagazione
        this.checkForPropagationPopup();
    }
    
    checkForPropagationPopup() {
        // Verifica se esiste un elemento con data attribute per la propagazione
        const propagationTrigger = document.querySelector('[data-show-propagation-popup]');
        
        if (propagationTrigger) {
            const eligibleUsersCount = propagationTrigger.dataset.eligibleUsersCount;
            const tableId = propagationTrigger.dataset.tableId;
            const viewName = propagationTrigger.dataset.viewName;
            const propagateUrl = propagationTrigger.dataset.propagateUrl;
            
            this.showPropagationDialog(eligibleUsersCount, tableId, viewName, propagateUrl);
        }
    }
    
    showPropagationDialog(eligibleUsersCount, tableId, viewName, propagateUrl) {
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                title: 'Propagare le impostazioni?',
                html: `Vuoi propagare queste impostazioni della vista Default a tutti i <strong>${eligibleUsersCount} utenti</strong> che non hanno ancora personalizzato questa vista?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sì, propaga!',
                cancelButtonText: 'No, mantieni solo per me',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    this.executePropagation(tableId, viewName, propagateUrl);
                }
            });
        } else {
            // Fallback se SweetAlert non è disponibile
            if (confirm(`Vuoi propagare queste impostazioni della vista Default a tutti i ${eligibleUsersCount} utenti che non hanno ancora personalizzato questa vista?`)) {
                this.executePropagationFallback(tableId, viewName, propagateUrl);
            }
        }
    }
    
    executePropagation(tableId, viewName, propagateUrl) {
        // Mostra loading
        Swal.fire({
            title: 'Propagazione in corso...',
            html: 'Sto aggiornando le impostazioni degli utenti',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        
        // Effettua la chiamata AJAX
        fetch(propagateUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
                target_table: tableId,
                view_name: viewName
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                Swal.fire({
                    title: 'Propagazione completata!',
                    html: data.message,
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
            } else {
                Swal.fire({
                    title: 'Errore',
                    html: data.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        })
        .catch(error => {
            console.error('Error:', error);
            Swal.fire({
                title: 'Errore di connessione',
                html: 'Si è verificato un errore durante la propagazione delle impostazioni.',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        });
    }
    
    executePropagationFallback(tableId, viewName, propagateUrl) {
        // Crea un form nascosto per fare la richiesta POST
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = propagateUrl;
        form.style.display = 'none';
        
        // Aggiungi CSRF token
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = '_token';
        csrfInput.value = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        form.appendChild(csrfInput);
        
        // Aggiungi target_table
        const tableInput = document.createElement('input');
        tableInput.type = 'hidden';
        tableInput.name = 'target_table';
        tableInput.value = tableId;
        form.appendChild(tableInput);
        
        // Aggiungi view_name
        const viewInput = document.createElement('input');
        viewInput.type = 'hidden';
        viewInput.name = 'view_name';
        viewInput.value = viewName;
        form.appendChild(viewInput);
        
        // Aggiungi al DOM e invia
        document.body.appendChild(form);
        form.submit();
    }
}
